import ApiService from "../apis/ApiService";
import { toast } from "react-toastify";

export async function ReportParteDiarioPDF(data) {
  try {
    console.log("📄 Generando parte diario PDF…", data["tipo"], data["data"]);
    const body = {
      tipo: data["tipo"],
      data: data["data"],
      size: "legal",
      orientation: data["tipo"] === "parte-diario" ? "landscape" : "portrait",
      margin: 2,
    };

    console.log("📄 Enviando parte diario PDF…", body);

    // 👇 LLAMA AL NUEVO CreateJson
    const result = await ApiService.CreateJson("reportes/generar", body);

    console.log("Resultado de imprimir reporte:", result);

    if (result.error || !result.url) {
      toast.error(result.msg || "No se pudo generar el PDF.");
      return;
    }

    // 👇 Abre el PDF directo
    window.open(result.url, "_blank");
  } catch (err) {
    console.error("❌ Error generando PDF:", err);
    alert("Error generando PDF: " + err.message);
  }
}
